<template>
    <div>
        <div class="footer-bar  " > 

            <div class="fb-like" style="float: right;margin-right: 2rem;" data-href="https://www.facebook.com/Autyzmump-517781748740718" data-layout="button_count" data-action="like" data-size="large" data-show-faces="false" data-share="false"></div> 
		 
 <div id="mc_embed_signup">
<form action="https://vxm.us19.list-manage.com/subscribe/post?u=0ccb6f47de539fd571d69b86e&amp;id=7b2e83ab41" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
    <div id="mc_embed_signup_scroll">
	<label for="mce-EMAIL">Zapisz się do Newsletter'a</label>
	<input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="Adres e-mail" required>
    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_0ccb6f47de539fd571d69b86e_7b2e83ab41" tabindex="-1" value=""></div>
    <div class="clear"><input type="submit" value="Zapisz się" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
    </div>
</form>
</div>
        </div>
		
		
        <img src="/static/footer.jpg" style="object-fit: contain;max-width: 1600px;width:100%;margin: auto;"/>
		
		
    </div>
</template>



<script>
    export default {
        name: 'Footer',
        data() {
            return {
                msg: this.$route.params.content_id
            }
        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue